import React, { Component } from 'react';
import Select from 'react-dropdown-select';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { wishlistDefault, shopBagDefault, signInDefault, searchDefault, switchAccount, signOutDefault } from '../common/MangoIcons';


class CsaOrderHome extends Component{
    render(){
        return(
            <React.Fragment>
                <section className="tab-product m-0">
                <div className="csa-home" style={{padding:30}}>
                    <div className="container">
                        <div className="container-tab mx-auto">
                            <div class="row">
                                <div class="col-md-8 mx-auto">

                                    {/* Title */}

                                    <div className="row" style={{paddingBottom:10}}>
                                        <div className="col-sm-12 text-center">
                                            <div className="mini-title">
                                                <span className="mx-auto">CSA Orders Home</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ paddingBottom: 70}}>
                                        <div className="row csa-home-list">
                                        <article className="col-md-6">
                                        <Link to="/awack">
                                        <div className="services-wrap" style={{padding:'40px 1px'}} >
                                           
                                            <div className="entry-container">
                                                <div className="entry-header" style={{marginBottom:'-14px',marginTop:'-10px'}}>
                                                    <h2 className="entry-title" style={{padding:13}}>
                                                        {/* <Link to=""> */}
                                                        Order Awaiting Acknowledgment 
                                                        {/* </Link> */}
                                                    </h2>
                                                </div>
                                                {/* <div className="read-more">
                                                    <Link to="" className="button">
                                                        Learn More
                                                    </Link>
                                                </div> */}
                                            </div>
                                        </div>
                                        </Link>
                                        </article>
  

                                        <article className="col-md-6">
                                        <Link to="/ack">
                                        <div className="services-wrap" style={{padding:'40px 1px'}} >
                                          

                                            <div className="entry-container">
                                                <div className="entry-header">
                                                    <h2 className="entry-title">
                                                        {/* <Link to="/csa-search"> */}
                                                        Order Acknowledge
                                                        {/* </Link> */}
                                                    </h2>
                                                </div>
                                            </div>
                                        </div>
                                        </Link>
                                        </article>

                                        <article className="col-md-6">
                                        <Link to="/pack">
                                        <div className="services-wrap" style={{padding:'40px 1px'}} >
                                            <div className="entry-container">
                                                <div className="entry-header">
                                                    <h2 className="entry-title">
                                                        {/* <Link to="/csa-consumer"> */}
                                                        Pack Order
                                                        {/* </Link> */}
                                                    </h2>
                                                </div>
                                            </div>
                                        </div>
                                        </Link>
                                        </article>

                                       

                                       

                                        </div>
                                    </div>
                                 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </section>        
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    csaVariants: state.csa.csaVariants,
    connection_id: state.tenant.connection_id,
    csaProducts: state.csa.csaProducts,
});

// const mapDispatchToProps = (dispatch) =>
//     bindActionCreators(
//         { getCSAProductList },
//         dispatch
//     );

export default connect(
    mapStateToProps,
    // mapDispatchToProps
)(withRouter(CsaOrderHome));